import React, { createContext, useContext, useState } from "react";

const RouteContext = createContext(null);

export function RouteProvider({ children }) {
  const [segments, setSegments] = useState([]);

  const addSegment = (seg) => setSegments((s) => [...s, { ...seg, _localId: Date.now() + Math.random() }]);
  const removeSegment = (id) => setSegments((s) => s.filter((x) => x._localId !== id));
  const clear = () => setSegments([]);

  return (
    <RouteContext.Provider value={{ segments, addSegment, removeSegment, clear }}>
      {children}
    </RouteContext.Provider>
  );
}

export const useRouteBuilder = () => useContext(RouteContext);
